import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { Autocomplete, IconButton, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import "./Production.css";
import AssignmentDetails from "../Campaign/AssignmentDetails";
import Loader from "../Components/Loader";
import { getListApplication } from "../Store/Actions/OutboundAction";

import {
  filteredAgentApp,
  filteredApplicationStatus,
  filteredCampaign,
  filteredTaskGroup,
} from "../Store/Actions/QAAction";

import { getAgentFilter } from "../Store/Actions/TicketAction";
import { SET_TABLE_PAGE } from "../Store/Types/TicketTypes";

export default function Production({ GenerateNonPopUpFiles }) {
  const [agentData, setAgentData] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [taskGroupData, setTaskGroupData] = useState([]);

  const initialParams = {
    contactName: "",
    status: "",
    agent: "",
    taskGroup: "",
    campaign: "",

    // Range initialized as 30 days before current date
    startSellingTime: moment().subtract(1, "months"),
    endSellingTime: moment(),
    startLastUpdate: moment().subtract(1, "months"),
    endLastUpdate: moment(),
  };

  const [searchParams, setSearchParams] = useState(initialParams);

  const initialDisplayValues = {
    agent: [],
    campaign: [],
    durationCall: [],
    status: [],
    taskGroup: [],
  };

  // Display values for autocomplete components
  const [displayValues, setDisplayValues] = useState(initialDisplayValues);

  const [isSearchLoading, setIsSearchLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [listApplication, setlistApplication] = useState([]);
  const dispatch = useDispatch();
  const { myInfo } = useSelector((state) => state.auth);
  const { tablePage } = useSelector((state) => state.ticket);

  // Run on first load, fetch tickets and get search options data
  useEffect(() => {
    setIsSearchLoading(true);
    fetchListApplication();

    // Get agent data for search select options
    getAgentFilter(myInfo.user.AgentID)
      .then((response) => {
        if (response.status) {
          console.log("agent data", response.data);
          setAgentData(response.data);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    filteredAgentApp()
      .then((response) => {
        if (response.status) {
          setAgentData(response.data);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    filteredApplicationStatus({ agentid: myInfo.user.AgentTSS.AgentID })
      .then((response) => {
        if (response.status) {
          setStatusData(response.data);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    filteredCampaign({ agentid: myInfo.user.AgentTSS.AgentID })
      .then((response) => {
        if (response.status) {
          setCampaignData(response.data);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    filteredTaskGroup()
      .then((response) => {
        if (response.status) {
          setTaskGroupData(response.data);
          setIsSearchLoading(false);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));
  }, []);

  function fetchListApplication() {
    setIsLoading(true);

    getListApplication({
      searchString: `contact=${searchParams.contactName}|status=${
        searchParams.status
      }|agent=${searchParams.agent}|taskgroup=${
        searchParams.taskGroup
      }|submit=${moment(searchParams.startSellingTime).format(
        "MM/DD/yyyy"
      )} - ${moment(searchParams.endSellingTime).format(
        "MM/DD/yyyy"
      )}|lastupdate=${moment(searchParams.startLastUpdate).format(
        "MM/DD/yyyy"
      )} - ${moment(searchParams.endSellingTime).format(
        "MM/DD/yyyy"
      )}|campaign=${searchParams.campaign}`,

      sorting: "",
      take: 10,
      skip: 0,
    })
      .then((response) => {
        if (response.status) {
          setlistApplication(response.data.data[0]);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  }

  function isTaskGroupDisabled() {
    if (
      !myInfo.user.AgentTSS ||
      myInfo.user.AgentTSS.TaskGroupCode.includes("AGENT")
    ) {
      return true;
    }

    return false;
  }

  const columns = [
    {
      field: "submittime",
      flex: 1.25,
      headerName: "Closing Time",

      renderCell: (params) =>
        params.row.submittime
          ? moment.utc(params.row.submittime).format("DD-MMM-yyyy HH:mm:ss")
          : "Not submitted",
    },

    {
      field: "personname",
      flex: 1,
      headerName: "Contact Name",
    },

    {
      field: "applicationtypename",
      flex: 1,
      headerName: "Application Type",
    },

    {
      field: "status",
      flex: 1,
      headerName: "App Status",
    },

    {
      field: "agentcode",
      flex: 1,
      headerName: "Created By",
    },

    {
      field: "taskgroupcode",
      flex: 1,
      headerName: "Task Group",
    },

    {
      field: "statustime",
      flex: 1.25,
      headerName: "Last Update",

      renderCell: (params) =>
        moment.utc(params.row.statustime).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      field: "Premi",
      flex: 1,
      headerName: "Premi",
    },

    {
      field: "spvname",
      flex: 1,
      headerName: "Nama SPV",
    },

    {
      field: "atmname",
      flex: 1,
      headerName: "Nama ATM",
    },

    {
      field: "Plan",
      flex: 1,
      headerName: "Plan",
    },

    {
      field: "PaymentFrekuensi",
      flex: 1,
      headerName: "Payment Frekuensi",
    },

    {
      field: "campaignname",
      flex: 1,
      headerName: "Campaign",
    },

    {
      field: "remarkqa",
      flex: 1,
      headerName: "Remark QA",
    },

    {
      align: "center",
      flex: 0.8,
      headerAlign: "center",
      headerName: "Action",

      renderCell: (params) => {
        return (
          <div>
            <IconButton
              onClick={() => setSelectedAssignment(params.row.assignmentid)}
            >
              <Icon
                color="#7e7e7e"
                height="26"
                icon="ic:baseline-remove-red-eye"
                width="26"
              />
            </IconButton>
          </div>
        );
      },
    },
  ];

  return (
    <div className="production">
      <div className="list_header">
        <div className="list_headerLeft">
          {selectedAssignment && (
            <Icon
              icon="material-symbols:arrow-back-ios-new-rounded"
              width="32"
              height="32"
              onClick={() => setSelectedAssignment(null)}
            />
          )}

          <div className="campaign-name">
            <h1>Production</h1>
          </div>
        </div>
      </div>

      <div className="containerProduction">
        {selectedAssignment ? (
          <AssignmentDetails
            assignmentID={selectedAssignment}
            setSelectedAssignment={setSelectedAssignment}
            GenerateNonPopUpFiles={GenerateNonPopUpFiles}
            isTelemarketing
          />
        ) : (
          <div className="production-contents">
            <div className="container-header">
              {isSearchLoading ? (
                <Loader />
              ) : (
                <div className="search">
                  <div className="row">
                    <TextField
                      className="search-item"
                      label="Contact Name"
                      value={searchParams.contactName}
                      onChange={(event) =>
                        setSearchParams({
                          ...searchParams,
                          contactName: event.target.value,
                        })
                      }
                    />

                    <Autocomplete
                      className="search-item"
                      filterSelectedOptions
                      multiple
                      options={statusData}
                      value={displayValues.status}
                      getOptionLabel={(status) => status}
                      onChange={(event, value) => {
                        setSearchParams({
                          ...searchParams,
                          status: value?.length ? value.map((val) => val) : "",
                        });

                        setDisplayValues({
                          ...displayValues,
                          status: value,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Status" />
                      )}
                    />

                    {myInfo.user.AgentTSS.TaskGroupCode === "AGENT" ? (
                      <Autocomplete
                        className="search-item agent"
                        filterSelectedOptions
                        multiple
                        options={agentData}
                        value={displayValues.agent}
                        getOptionLabel={(agent) => agent.Name}
                        onChange={(event, value) => {
                          setSearchParams({
                            ...searchParams,
                            agent: value?.length
                              ? value.map((val) => val.ID)
                              : "",
                          });

                          setDisplayValues({
                            ...displayValues,
                            agent: value,
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Agent" />
                        )}
                      />
                    ) : (
                      <div className="search-item agent" />
                    )}

                    <button
                      className="clear-button"
                      onClick={() => setSearchParams(initialParams)}
                    >
                      <Icon icon="ri:brush-3-line" width="20" height="20" />
                      Clear
                    </button>
                  </div>

                  <div className="row">
                    <Autocomplete
                      className="search-item"
                      disabled={isTaskGroupDisabled()}
                      filterSelectedOptions
                      multiple
                      options={taskGroupData}
                      value={displayValues.taskGroup}
                      getOptionLabel={(taskGroup) => taskGroup.TaskGroupCode}
                      onChange={(event, value) => {
                        setSearchParams({
                          ...searchParams,
                          taskGroup: value?.length
                            ? value.map((val) => val.TaskGroupCode)
                            : "",
                        });

                        setDisplayValues({
                          ...displayValues,
                          taskGroup: value,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Task Group" />
                      )}
                    />

                    <Autocomplete
                      className="search-item"
                      filterSelectedOptions
                      multiple
                      options={campaignData}
                      value={displayValues.campaign}
                      getOptionLabel={(campaign) => campaign.Name}
                      onChange={(event, value) => {
                        setSearchParams({
                          ...searchParams,
                          campaign: value?.length
                            ? value.map((val) => val.ID)
                            : "",
                        });

                        setDisplayValues({
                          ...displayValues,
                          campaign: value,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Campaign" />
                      )}
                    />

                    <p className="search-item"> </p>

                    <button
                      className="search-button"
                      onClick={fetchListApplication}
                    >
                      <Icon height="20" icon="mingcute:search-line" />
                      Search
                    </button>
                  </div>

                  <div className="row">
                    <div className="date-range">
                      <DatePicker
                        disableFuture
                        label="Start Selling Time"
                        maxDate={searchParams.endSellingTime}
                        value={searchParams.startSellingTime}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(newValue) =>
                          setSearchParams({
                            ...searchParams,
                            startSellingTime: newValue,
                          })
                        }
                      />

                      <Icon
                        color="#7E7E7E"
                        icon="mdi:arrow-expand"
                        width="24"
                      />

                      <DatePicker
                        disableFuture
                        label="End Selling Time"
                        minDate={searchParams.startSellingTime}
                        value={searchParams.endSellingTime}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(newValue) =>
                          setSearchParams({
                            ...searchParams,
                            endSellingTime: newValue,
                          })
                        }
                      />
                    </div>

                    <div className="date-range">
                      <DatePicker
                        disableFuture
                        label="Start Last Update"
                        maxDate={searchParams.endLastUpdate}
                        value={searchParams.startLastUpdate}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(newValue) =>
                          setSearchParams({
                            ...searchParams,
                            startLastUpdate: newValue,
                          })
                        }
                      />

                      <Icon
                        color="#7E7E7E"
                        icon="mdi:arrow-expand"
                        width="24"
                      />

                      <DatePicker
                        disableFuture
                        label="End Last Update"
                        minDate={searchParams.startLastUpdate}
                        value={searchParams.endLastUpdate}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(newValue) =>
                          setSearchParams({
                            ...searchParams,
                            endLastUpdate: newValue,
                          })
                        }
                      />
                    </div>

                    {/* Fillers */}
                    <button className="clear-button filler" />
                  </div>
                </div>
              )}
            </div>

            <div className="container-body">
              <DataGrid
                autoPageSize
                className="table"
                columns={columns}
                disableColumnFilter
                disableColumnMenu
                disableSelectionOnClick
                headerHeight={75}
                loading={isLoading}
                page={tablePage}
                rows={listApplication}
                getRowHeight={() => "auto"}
                getRowId={(row) => row.applicationid}
                onPageChange={(newPage) =>
                  dispatch({
                    type: SET_TABLE_PAGE,
                    payload: { tablePage: newPage },
                  })
                }
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
